const robPermissions = Object.freeze({
  // Survey actions
  APPROVE_SURVEY: 'APPROVE_SURVEY',

  // Bunker tab
  EDIT_BARGE_TANK: 'EDIT_BARGE_TANK',
  EDIT_BUNKER_INFO: 'EDIT_BUNKER_INFO',

  // Fuel, Sludge, Bilge & Comments section (within General)
  EDIT_FUEL_SLUDGE_BILGE: 'EDIT_FUEL_SLUDGE_BILGE',

  // Fuel Tanks tab
  EDIT_FUEL_TANKS: 'EDIT_FUEL_TANKS',

  // General tab
  EDIT_GENERAL: 'EDIT_GENERAL',

  // Laboratory sub-tab (within Bunker)
  EDIT_LABORATORY: 'EDIT_LABORATORY',

  // Seals section (within General)
  EDIT_SEALS: 'EDIT_SEALS',

  // Sludge & Oil Bilge tab
  EDIT_SLUDGE_OIL_BILGE: 'EDIT_SLUDGE_OIL_BILGE',

  // Sounding, Draft & Temperature section (within General)
  EDIT_SOUNDING: 'EDIT_SOUNDING',

  // Survey actions
  SUBMIT_SURVEY: 'SUBMIT_SURVEY',

  // Bunker tab
  VIEW_BUNKER: 'VIEW_BUNKER',

  // Fuel, Sludge, Bilge & Comments section (within General)
  VIEW_FUEL_SLUDGE_BILGE: 'VIEW_FUEL_SLUDGE_BILGE',

  // Fuel Tanks tab
  VIEW_FUEL_TANKS: 'VIEW_FUEL_TANKS',

  // General tab
  VIEW_GENERAL: 'VIEW_GENERAL',

  // Laboratory sub-tab (within Bunker)
  VIEW_LABORATORY: 'VIEW_LABORATORY',

  // Seals section (within General)
  VIEW_SEALS: 'VIEW_SEALS',

  // Sludge & Oil Bilge tab
  VIEW_SLUDGE_OIL_BILGE: 'VIEW_SLUDGE_OIL_BILGE',

  // Sounding, Draft & Temperature section (within General)
  VIEW_SOUNDING: 'VIEW_SOUNDING',
})

export default robPermissions
